/* ============================================================
   section-stats.js — GSAP count-up triggered on scroll into view.
   Hooks: data-stat (card), data-stat-number, data-target
   ============================================================ */

(function () {
  function setup() {
    gsap.registerPlugin(window.ScrollTrigger);

    document.querySelectorAll('[data-stat]').forEach(function (card) {
      if (card._statAnimated) return;
      card._statAnimated = true;

      var num = card.querySelector('[data-stat-number]');
      if (!num) return;
      var raw = num.getAttribute('data-target') || '0';
      var target = parseFloat(raw) || 0;
      // Preserve leading-zero formatting (e.g. "07" or "08").
      var pad = (raw.charAt(0) === '0' && target > 0) ? raw.length : 0;
      function fmt(n) {
        var s = String(n);
        return pad > s.length ? s.padStart(pad, '0') : s;
      }
      var counter = { val: 0 };

      gsap.to(counter, {
        val: target,
        duration: 1.6,
        ease: 'power2.out',
        scrollTrigger: { trigger: card, start: 'top 70%', once: true },
        onUpdate: function () { num.textContent = fmt(Math.round(counter.val)); },
        onComplete: function () { num.textContent = raw; }
      });
    });
  }

  function init(retries) {
    retries = retries || 0;
    if (window.gsap && window.ScrollTrigger) return setup();
    if (retries < 50) setTimeout(function () { init(retries + 1); }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(0); });
  } else {
    init(0);
  }
  document.addEventListener('shopify:section:load', function () { init(0); });
})();
